export const dropDownMenuMetaData = {
    isRepeatable: false
}
